/* MO3S shared card logic: wishlist, add to cart (qty), buy now, popup w/ slider+qty, product toast */
(function () {
  if (window.MO3S_CARDS_INIT) return;
  window.MO3S_CARDS_INIT = true;

  var L = window.MO3S_CART_LABELS || {};
  var LBL = {
    added: L.added || 'تمت إضافة المنتج إلى سلة التسوق بنجاح!',
    added_short: L.added_short || 'تم اضافة المنتج للسلة',
    qty: L.qty || 'الكمية:',
    total: L.total || 'الإجمالي:',
    checkout: L.checkout || 'إتمام الطلب',
    continue: L.continue || 'متابعة التسوق',
    error: L.error || 'تعذر إضافة المنتج، حاول مرة أخرى'
  };
  var MONEY = window.MO3S_MONEY_FORMAT || '{{amount}} ر.س';
  function fm(cents) { return MONEY.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var WKEY = 'mo3s_wishlist';
  var HEART_SVG = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21s-7.5-4.8-10-9.3C.6 8.6 2.4 5 5.9 5c2 0 3.4 1.1 4.1 2.3h4c.7-1.2 2.1-2.3 4.1-2.3 3.5 0 5.3 3.6 3.9 6.7C19.5 16.2 12 21 12 21z" transform="scale(0.92) translate(1,0.5)"/></svg>';
  function getW() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function setW(l) { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {} }
  function initHearts(root) {
    var wl = getW();
    (root || document).querySelectorAll('[data-mo3s-heart]').forEach(function (btn) {
      if (!btn.innerHTML.trim()) btn.innerHTML = HEART_SVG;
      btn.classList.toggle('is-active', wl.indexOf(btn.getAttribute('data-mo3s-heart')) !== -1);
    });
  }
  window.MO3S_INIT_HEARTS = initHearts;

  var css = '';
  css += '.mo3s-pop__overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:130;opacity:0;pointer-events:none;transition:opacity .25s}';
  css += '.mo3s-pop__overlay.is-open{opacity:1;pointer-events:auto}';
  css += '.mo3s-pop{position:fixed;left:50%;top:50%;transform:translate(-50%,-46%);width:min(92vw,420px);max-height:88vh;overflow:hidden auto;background:#fff;border-radius:18px;z-index:131;opacity:0;pointer-events:none;transition:opacity .25s,transform .25s;box-shadow:0 20px 60px rgba(0,0,0,.28)}';
  css += '.mo3s-pop.is-open{opacity:1;pointer-events:auto;transform:translate(-50%,-50%)}';
  css += '.mo3s-pop__head{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:16px 18px 12px}';
  css += '.mo3s-pop__head h3{font-size:15px;font-weight:700;color:#111;margin:0}';
  css += '.mo3s-pop__close{border:none;background:none;font-size:22px;line-height:1;cursor:pointer;color:#111;padding:2px 4px}';
  css += '.mo3s-pop__divider{height:1px;background:#eee;margin:0 18px}';
  css += '.mo3s-pop__slider{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;margin:16px 18px 0;border-radius:12px;background:#f6f6f6;scrollbar-width:none}';
  css += '.mo3s-pop__slider::-webkit-scrollbar{display:none}';
  css += '.mo3s-pop__slide{flex:0 0 100%;scroll-snap-align:center;aspect-ratio:16/11}';
  css += '.mo3s-pop__slide img{width:100%;height:100%;object-fit:cover;display:block}';
  css += '.mo3s-pop__dots{display:flex;justify-content:center;gap:6px;margin:10px 0 4px}';
  css += '.mo3s-pop__dots button{width:6px;height:6px;border-radius:50%;border:none;background:#d6d6d6;padding:0;cursor:pointer}';
  css += '.mo3s-pop__dots button.is-active{background:#111;width:16px;border-radius:999px}';
  css += '.mo3s-pop__row{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:10px 18px 0}';
  css += '.mo3s-pop__name{font-size:14px;font-weight:700;color:#111;text-decoration:none;line-height:1.6;flex:1}';
  css += '.mo3s-pop__price{font-size:14px;font-weight:800;color:#111;white-space:nowrap}';
  css += '.mo3s-pop__meta{display:flex;align-items:center;justify-content:space-between;padding:12px 18px;font-size:13px;color:#555;border-top:1px solid #f0f0f0;margin-top:12px}';
  css += '.mo3s-pop__meta+.mo3s-pop__meta{border-bottom:1px solid #f0f0f0}';
  css += '.mo3s-pop__meta strong{color:#111;font-weight:800}';
  css += '.mo3s-pop__qty{display:flex;align-items:center;border:1px solid #d6d6d6;border-radius:999px;overflow:hidden}';
  css += '.mo3s-pop__qty button{width:32px;height:32px;background:#fff;border:none;font-size:16px;cursor:pointer;color:#111;line-height:1}';
  css += '.mo3s-pop__qty span{min-width:38px;text-align:center;font-size:13px;font-weight:700;color:#111}';
  css += '.mo3s-pop__actions{padding:14px 18px 18px;display:flex;flex-direction:column;gap:9px}';
  css += '.mo3s-pop__btn{width:100%;text-align:center;border-radius:999px;padding:13px;font-size:14px;font-weight:700;cursor:pointer;border:1.5px solid #111;text-decoration:none;display:block}';
  css += '.mo3s-pop__btn--pay{background:#111;color:#fff}';
  css += '.mo3s-pop__btn--cont{background:#fff;color:#111}';
  css += '@keyframes mo3sShake{0%,100%{transform:translateX(0)}15%{transform:translateX(-3px) rotate(-6deg)}30%{transform:translateX(3px) rotate(6deg)}45%{transform:translateX(-3px) rotate(-5deg)}60%{transform:translateX(3px) rotate(4deg)}75%{transform:translateX(-2px) rotate(-2deg)}}';
  css += '.mo3s-cart-shake{animation:mo3sShake .6s ease}';
  css += '.mo3s-ptoast{position:fixed;left:50%;top:12px;transform:translate(-50%,-160%);background:#111;color:#fff;z-index:125;border-radius:999px;padding:12px 22px;display:flex;align-items:center;justify-content:center;box-shadow:0 8px 24px rgba(0,0,0,.25);transition:transform .32s cubic-bezier(.22,.8,.36,1);max-width:92vw;text-decoration:none;cursor:pointer}';
  css += '.mo3s-ptoast.is-open{transform:translate(-50%,0)}';
  css += '.mo3s-ptoast__msg{font-size:13.5px;font-weight:700;white-space:nowrap;color:#fff}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function addToCart(id, qty) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: qty || 1 })
    }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'err'); }); return r.json(); });
  }
  window.MO3S_ADD_TO_CART = addToCart;

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
      if (bubbles.length) { bubbles.forEach(function (s) { s.textContent = cart.item_count; }); return cart; }
      return fetch(window.location.pathname + '?sections=header').then(function (r) { return r.json(); }).then(function (data) {
        if (!data.header) return cart;
        var temp = document.createElement('div'); temp.innerHTML = data.header;
        var fresh = temp.querySelector('.header') || temp.firstElementChild;
        var live = document.querySelector('[id$="__header"]') || document.querySelector('.header-wrapper');
        if (fresh && live) { (live.querySelector('.header') || live).innerHTML = fresh.innerHTML; }
        return cart;
      }).catch(function () { return cart; });
    }).catch(function () { return null; });
  }
  window.MO3S_REFRESH_CART = refreshCartCount;

  function shakeCart() {
    document.querySelectorAll('#cart-icon-bubble, .header__icon--cart').forEach(function (el) {
      el.classList.remove('mo3s-cart-shake'); void el.offsetWidth; el.classList.add('mo3s-cart-shake');
    });
  }
  window.MO3S_SHAKE_CART = shakeCart;

  /* ---------- full popup with slider + qty ---------- */
  var pop, overlay;
  var closeTimer = null;
  var popState = { key: null, unitPrice: 0, qty: 1 };
  function buildPop() {
    overlay = document.createElement('div'); overlay.className = 'mo3s-pop__overlay';
    pop = document.createElement('div'); pop.className = 'mo3s-pop'; pop.setAttribute('role', 'dialog');
    document.body.appendChild(overlay); document.body.appendChild(pop);
    overlay.addEventListener('click', closePop);
  }
  function stopTimer() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  }
  function closePop() {
    stopTimer();
    if (pop) pop.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
  }
  function updatePopTotals() {
    var totalEl = pop.querySelector('[data-mo3s-pop-total]');
    var qtyEl = pop.querySelector('[data-mo3s-pop-qtyval]');
    if (qtyEl) qtyEl.textContent = '× ' + popState.qty;
    if (totalEl) totalEl.textContent = fm(popState.unitPrice * popState.qty);
  }
  function renderPop(item, product, cartLine) {
    if (!pop) buildPop();
    popState.key = item.key;
    // Determine unit price in CENTS reliably.
    var unit = null;
    if (product && product.variants && product.variants.length) {
      var v = product.variants.filter(function (vv) { return Number(vv.id) === Number(item.variant_id || item.id); })[0];
      if (v && typeof v.price === 'number') unit = v.price;
      else if (typeof product.price === 'number') unit = product.price;
    }
    if (unit === null && cartLine && typeof cartLine.price === 'number') unit = cartLine.price;
    if (unit === null) unit = item.price || 0;
    popState.unitPrice = unit;
    popState.qty = item.quantity || 1;
    var name = item.product_title || item.title || (product && product.title) || '';
    var url = item.url || (product && product.url) || '#';
    var images = product && product.images ? product.images : null;
    var imgs = (images && images.length) ? images : (item.image ? [item.image] : []);
    var slides = '', dots = '';
    imgs.forEach(function (src, i) {
      var u = src.indexOf('?') === -1 ? src + '?width=700' : src;
      slides += '<div class="mo3s-pop__slide" data-i="' + i + '"><img src="' + u + '" alt="' + esc(name) + '"></div>';
      dots += '<button type="button" data-mo3s-goto="' + i + '"' + (i === 0 ? ' class="is-active"' : '') + '></button>';
    });
    pop.innerHTML =
      '<div class="mo3s-pop__head"><h3>' + esc(LBL.added) + '</h3><button type="button" class="mo3s-pop__close" data-mo3s-pop-close aria-label="close">&times;</button></div>' +
      '<div class="mo3s-pop__divider"></div>' +
      (imgs.length ? '<div class="mo3s-pop__slider">' + slides + '</div>' + (imgs.length > 1 ? '<div class="mo3s-pop__dots">' + dots + '</div>' : '') : '') +
      '<div class="mo3s-pop__row"><a href="' + url + '" class="mo3s-pop__name">' + esc(name) + '</a><span class="mo3s-pop__price">' + fm(popState.unitPrice) + '</span></div>' +
      '<div class="mo3s-pop__meta"><span>' + esc(LBL.qty) + '</span>' +
        '<div class="mo3s-pop__qty"><button type="button" data-mo3s-pop-minus aria-label="-">&minus;</button><span data-mo3s-pop-qtyval>× ' + popState.qty + '</span><button type="button" data-mo3s-pop-plus aria-label="+">&plus;</button></div></div>' +
      '<div class="mo3s-pop__meta"><span>' + esc(LBL.total) + '</span><strong data-mo3s-pop-total>' + fm(popState.unitPrice * popState.qty) + '</strong></div>' +
      '<div class="mo3s-pop__actions"><a href="/checkout" class="mo3s-pop__btn mo3s-pop__btn--pay">' + esc(LBL.checkout) + '</a>' +
      '<button type="button" class="mo3s-pop__btn mo3s-pop__btn--cont" data-mo3s-pop-close>' + esc(LBL.continue) + '</button></div>';
    pop.querySelectorAll('[data-mo3s-pop-close]').forEach(function (b) { b.addEventListener('click', closePop); });

    var slider = pop.querySelector('.mo3s-pop__slider');
    var dotEls = pop.querySelectorAll('[data-mo3s-goto]');
    if (slider && dotEls.length > 1 && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            var idx = parseInt(en.target.getAttribute('data-i'), 10) || 0;
            dotEls.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
          }
        });
      }, { root: slider, threshold: 0.6 });
      slider.querySelectorAll('.mo3s-pop__slide').forEach(function (s) { obs.observe(s); });
      dotEls.forEach(function (d) {
        d.addEventListener('click', function () {
          var idx = parseInt(d.getAttribute('data-mo3s-goto'), 10) || 0;
          var target = slider.querySelector('[data-i="' + idx + '"]');
          if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });
    }

    function restartClose() { stopTimer(); closeTimer = setTimeout(closePop, 5000); }
    var minus = pop.querySelector('[data-mo3s-pop-minus]');
    var plus = pop.querySelector('[data-mo3s-pop-plus]');
    if (minus) minus.addEventListener('click', function () {
      if (popState.qty <= 1) return;
      popState.qty--; updatePopTotals(); restartClose();
      changeLine(popState.key, popState.qty).then(function () { refreshCartCount(); });
    });
    if (plus) plus.addEventListener('click', function () {
      popState.qty++; updatePopTotals(); restartClose();
      changeLine(popState.key, popState.qty).then(function () { refreshCartCount(); });
    });

    requestAnimationFrame(function () { overlay.classList.add('is-open'); pop.classList.add('is-open'); });
    stopTimer();
    closeTimer = setTimeout(closePop, 5000);
  }
  function showPop(item, handle) {
    var pProduct = handle
      ? fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      : Promise.resolve(null);
    var pCart = fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    Promise.all([pProduct, pCart]).then(function (res) {
      var product = res[0];
      var cart = res[1];
      var line = null;
      if (cart && cart.items) {
        line = cart.items.filter(function (it) { return it.key === item.key || Number(it.variant_id) === Number(item.variant_id || item.id); })[0] || null;
      }
      renderPop(item, product, line);
    });
  }
  window.MO3S_SHOW_POP = showPop;

  /* ---------- product-page top toast (no redirect) ---------- */
  var ptoast, ptoastTimer;
  function showProductToast() {
    if (!ptoast) {
      ptoast = document.createElement('a'); ptoast.className = 'mo3s-ptoast';
      ptoast.href = (window.routes && window.routes.cart_url) || '/cart';
      ptoast.innerHTML = '<span class="mo3s-ptoast__msg">' + esc(LBL.added_short) + '</span>';
      document.body.appendChild(ptoast);
    }
    requestAnimationFrame(function () { ptoast.classList.add('is-open'); });
    clearTimeout(ptoastTimer);
    ptoastTimer = setTimeout(function () { ptoast.classList.remove('is-open'); }, 4000);
  }
  window.MO3S_PRODUCT_TOAST = function () { shakeCart(); showProductToast(); };

  /* ---------- click handling ---------- */
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-mo3s-heart]');
    if (heart) {
      var h = heart.getAttribute('data-mo3s-heart');
      var wl = getW(); var i = wl.indexOf(h);
      if (i === -1) { wl.push(h); } else { wl.splice(i, 1); }
      setW(wl); heart.classList.toggle('is-active', i === -1);
      return;
    }

    var cminus = e.target.closest('[data-mo3s-cardqty-minus]');
    if (cminus) {
      var box1 = cminus.closest('[data-mo3s-cardqty]');
      var val1 = box1.querySelector('[data-mo3s-cardqty-val]');
      val1.textContent = Math.max(1, (parseInt(val1.textContent, 10) || 1) - 1);
      return;
    }
    var cplus = e.target.closest('[data-mo3s-cardqty-plus]');
    if (cplus) {
      var box2 = cplus.closest('[data-mo3s-cardqty]');
      var val2 = box2.querySelector('[data-mo3s-cardqty-val]');
      val2.textContent = (parseInt(val2.textContent, 10) || 1) + 1;
      return;
    }

    var atc = e.target.closest('.mo3s-card__atc');
    if (atc && atc.getAttribute('data-variant-id')) {
      e.preventDefault();
      var card = atc.closest('.mo3s-card');
      var qEl = card ? card.querySelector('[data-mo3s-cardqty-val]') : null;
      var q = qEl ? Math.max(1, parseInt(qEl.textContent, 10) || 1) : 1;
      var handle = atc.getAttribute('data-handle');
      atc.disabled = true;
      addToCart(atc.getAttribute('data-variant-id'), q).then(function (item) {
        atc.disabled = false;
        if (qEl) qEl.textContent = 1;
        shakeCart();
        refreshCartCount();
        showPop(item, handle);
      }).catch(function () { atc.disabled = false; alert(LBL.error); });
      return;
    }

    var buy = e.target.closest('.mo3s-card__buy');
    if (buy && buy.getAttribute('data-variant-id')) {
      e.preventDefault();
      var card2 = buy.closest('.mo3s-card');
      var qEl2 = card2 ? card2.querySelector('[data-mo3s-cardqty-val]') : null;
      var q2 = qEl2 ? Math.max(1, parseInt(qEl2.textContent, 10) || 1) : 1;
      buy.disabled = true;
      addToCart(buy.getAttribute('data-variant-id'), q2).then(function () { window.location.href = '/checkout'; })
        .catch(function () { buy.disabled = false; alert(LBL.error); });
    }
  });

  /* ---------- product-page add-to-cart -> top toast, stay on page ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'mo3sProductForm') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var idEl = document.getElementById('mo3sVariantId');
    var qinput = document.getElementById('mo3sQty');
    var vid = idEl ? Number(idEl.value) : null;
    var qty = qinput ? Math.max(1, parseInt(qinput.value, 10) || 1) : 1;
    if (!vid) return;
    var btn = document.getElementById('mo3sBuyBtn');
    if (btn) btn.disabled = true;
    addToCart(vid, qty).then(function () {
      if (btn) btn.disabled = false;
      refreshCartCount();
      shakeCart();
      showProductToast();
    }).catch(function () { if (btn) btn.disabled = false; alert(LBL.error); });
  }, true);

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initHearts(); }); } else { initHearts(); }
  document.addEventListener('shopify:section:load', function (e) { initHearts(e.target); });
})();
